// AUTO-GENERATED from servers/common-servers-v2/helpers/FormHelper/normalize_fa.js by servers/common-servers-v2/scripts/sync-form-helper.js.
// Do not edit: change the source and run `node scripts/sync-form-helper.js`.
/* eslint-disable */
/*
 * Persian text normalization used for search (spec §10), dedupe and tests.
 * Arabic ي/ى/ك -> ی/ک, Arabic/Persian digits -> Latin, ZWNJ/ZWJ, diacritics and
 * tatweel removed, lowercase, whitespace collapsed.
 */

const normalize_digits = (value) => String(value ?? "").replace(/[\u0660-\u0669\u06F0-\u06F9]/g, (char) => {
    const code = char.charCodeAt(0);
    return String(code >= 0x06f0 ? code - 0x06f0 : code - 0x0660);
});

const normalize_fa = (value) => {
    if (value === undefined || value === null) {
        return "";
    }
    return normalize_digits(String(value))
        .replace(/[\u064A\u0649]/g, "\u06CC")
        .replace(/\u0643/g, "\u06A9")
        .replace(/\u200C|\u200D|[\u064B-\u0652\u0670]|\u0640/g, "")
        .toLowerCase()
        .replace(/\s+/g, " ")
        .trim();
};

export {
    normalize_fa,
    normalize_digits,
};
